import { render, staticRenderFns } from "./form_categories_component.vue?vue&type=template&id=5dd8028d&scoped=true"
import script from "./form_categories_component.vue?vue&type=script&lang=js"
export * from "./form_categories_component.vue?vue&type=script&lang=js"
import style0 from "./form_categories_component.vue?vue&type=style&index=0&id=5dd8028d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8028d",
  null
  
)

export default component.exports